var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],staticClass:"p-0",attrs:{"variant":"link","title":"Copy Link to Clipboard"},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.copyLink.apply(null, arguments)}}},[_c('i',{staticClass:"fas fa-copy"})])
}
var staticRenderFns = []

export { render, staticRenderFns }